var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Navigation',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_c('Header',{on:{"toggleNavigation":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_c('v-main',[_c('keep-alive',{attrs:{"include":'Reports'}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }